// Сравнение TDLib message id — int64, сериализованные десятичными строками.
// Лексикографическое сравнение строк некорректно (разная длина), поэтому BigInt.
// На мусорных значениях оба хелпера консервативно возвращают false.

/** true, если id <= boundary (сообщение прочитано относительно отметки). */
export const isMessageIdAtMost = (
  id: string | undefined,
  boundary: string | undefined
): boolean => {
  if (!id || !boundary) {
    return false;
  }
  try {
    return BigInt(id) <= BigInt(boundary);
  } catch {
    return false;
  }
};

/**
 * Порядковое сравнение id: -1 / 0 / 1. Нужен как tie-break при сортировке
 * ленты — у сообщений одной секунды одинаковый occurredAt (TDLib отдаёт
 * дату с точностью до секунды), и порядок решает именно id.
 * Оптимистичные локальные id ("optimistic:…") в BigInt не парсятся —
 * для них падаем на строковое сравнение.
 */
export const compareMessageIds = (left: string, right: string): number => {
  try {
    const leftId = BigInt(left);
    const rightId = BigInt(right);
    return leftId < rightId ? -1 : leftId > rightId ? 1 : 0;
  } catch {
    return left.localeCompare(right);
  }
};

/** true, если id > boundary (сообщение новее отметки). */
export const isMessageIdAfter = (
  id: string | undefined,
  boundary: string | undefined
): boolean => {
  if (!id || !boundary) {
    return false;
  }
  try {
    return BigInt(id) > BigInt(boundary);
  } catch {
    return false;
  }
};
